import React from 'react';

import GlobalStyles from '@mui/material/GlobalStyles';

const ROW_HEIGHT = 62;

const AgGridStyles = () => {
  return (
    <GlobalStyles
      styles={() => ({
        '.ag-theme-dokka': {
          '&': {
            '--ag-row-height': `${ROW_HEIGHT}px`,
          },

          '& .ag-row': {
            maxHeight: ROW_HEIGHT,

            '&.ag-row-group-expanded': {
              '& .ag-column-first': {
                borderLeft: '3px solid #000',
              },
            },

            '&.ag-row-level-1': {
              borderRadius: 0,
              maxHeight: 72,

              '& .ag-column-first': {
                display: 'none',
              },

              '& .custom-first-visible': {
                borderLeft: '3px solid #000',
              },

              '& .ag-cell': {
                height: 62,
                borderRadius: 0,
                borderBottom: 'none',
              },

              '&.first-level-1': {
                '& .custom-first-visible': {
                  borderRadius: '8px 0 0 0',
                },

                '& .custom-last-visible': {
                  borderRadius: '0 8px 0 0',
                },
              },

              '&.last-level-1': {
                '& .ag-cell': {
                  borderBottom: '1px solid var(--ag-border-color)',
                },

                '& .custom-first-visible': {
                  borderRadius: '0 0 0 8px',
                },

                '& .custom-last-visible': {
                  borderRadius: '0 0 8px 0',
                },
              },

              '&.only-level-1': {
                '& .custom-first-visible + .ag-cell': {
                  borderRadius: '8px 0 0 8px',
                },

                '& .custom-last-visible': {
                  borderRadius: '0 8px 8px 0',
                },
              },
            },
          },

          '& .ag-column-first': {
            borderRadius: '8px 0 0 8px',
            borderLeft: '1px solid var(--ag-border-color)',
          },

          '& .ag-column-last': {
            borderRadius: '0 8px 8px 0',
            borderRight: '1px solid var(--ag-border-color) !important',
          },

          // AG Grid 36 insets the sparkline by the theme's cell padding; the trend cell has no
          // padding, and on 34 the bars started at its edge.
          '& .ag-sparkline-wrapper': {
            insetInlineStart: 0,
          },
        },
      })}
    />
  );
};

export default AgGridStyles;
